import React, { Component } from 'react';
import TextField from '@mui/material/TextField';

class ReflexRuleSearchMenu extends Component {
    render() {
        return (
            <div className="row" style={{ padding: '12px' }}>
                <div className="col-md-3">
                    <TextField
                        label="Search Rules"
                        variant="outlined"
                        id="reset-form"
                        InputLabelProps={{
                            shrink: true
                        }}
                        type="string"
                        margin="dense"
                        onChange={this.props.onFilterTextChange}
                    />
                </div>
                <div className="col-md-2">
                    <button className="btn btn-primary button-info-grid" onClick={() => this.props.clearFilter()}>
                        <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                    </button>
                </div>
                <div className="col-md-7" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                        <label style={{ marginRight: '5px' }}>Page Size: </label>
                        <input
                            type="number"
                            id="page-size"
                            min="1"
                            max="1000"
                            value={this.props.pageSize || 20}
                            onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (value > 0 && value <= 1000) {
                                    this.props.onPageSizeChanged(e);
                                }
                            }}
                            onBlur={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (!value || value < 1) {
                                    e.target.value = 20;
                                    this.props.onPageSizeChanged(e);
                                } else if (value > 1000) {
                                    e.target.value = 1000;
                                    this.props.onPageSizeChanged(e);
                                }
                            }}
                            style={{ 
                                marginLeft: '5px',
                                width: '80px',
                                padding: '4px 8px',
                                border: '1px solid #ced4da',
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                    <div>
                        <button
                            className="btn btn-primary button-info-grid"
                            onClick={() => this.props.saveState()}
                        >
                            <i className="fa fa-save" aria-hidden="true"></i> Save View
                        </button>
                    </div>
                    <div>
                        <button
                            className="btn btn-primary button-info-grid"
                            onClick={() => this.props.resetState()}
                        >
                            <i className="fa fa-undo" aria-hidden="true"></i> Reset View
                        </button>
                    </div>
                    <div>
                        <button
                            className="btn btn-primary button-info-grid"
                            onClick={() => this.props.onBtnExport()}
                        >
                            <i className="fa fa-file-excel-o" aria-hidden="true"></i> Export
                        </button>
                    </div>
                    {this.props.handleCreate && (
                        <div>
                            <button
                                className="btn btn-primary button-info-grid"
                                onClick={() => this.props.handleCreate()}
                            >
                                <i className="fa fa-plus" aria-hidden="true"></i> Add Rule
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default ReflexRuleSearchMenu;